import { H1 } from "@dune/ui";
import { GoBackButton } from "../../../component/common/GoBackButton";
import { Page } from "../../../component/common/Page";
import { FileWithMetadataPreviewWrapper } from "../../../component/layout/FileWithMetadataPreviewWrapper";
import { useRequiredParams } from "../../../hooks/useRequiredParams";
import { getConstructionSiteTitle } from "../ConstructionSitePage";
import { ReceptionAnalysisContent } from "./ReceptionAnalysisContent";

export const ReceptionAnalysis = () => {
	const { constructionSiteId } = useRequiredParams<{
		constructionSiteId: string;
	}>();

	return (
		<Page>
			<FileWithMetadataPreviewWrapper>
				<div>
					<GoBackButton />
					<H1 className="mt-2">
						Analyse réception de{" "}
						{getConstructionSiteTitle(Number(constructionSiteId))}
					</H1>
				</div>
				<ReceptionAnalysisContent />
			</FileWithMetadataPreviewWrapper>
		</Page>
	);
};

export default ReceptionAnalysis;
